import * as React from "react";
const SvgActivecampaign = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 3.5 16.5 12 8 20.5", stroke: "#356AE6", strokeWidth: 3.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgActivecampaign;
